import * as React from 'react';

const LogoutIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.529 17.929a.887.887 0 0 1-.304-1.388c.282-.322.13-.308 3.326-.309 1.953 0 2.907-.016 3.022-.048.225-.062.546-.384.608-.608.066-.24.066-12.907 0-13.147-.062-.224-.383-.546-.608-.608-.115-.032-1.069-.047-3.022-.048-3.196-.001-3.044.013-3.326-.308A.886.886 0 0 1 9.529.077C9.688.005 9.886 0 12.679 0c2.476 0 3.023.01 3.243.062a2.746 2.746 0 0 1 1.81 1.445c.29.578.276.15.262 7.622l-.011 6.743-.098.275a2.839 2.839 0 0 1-1.726 1.736l-.29.103-3.085.01c-2.918.01-3.095.006-3.255-.067Zm-5.312-4.46a1.404 1.404 0 0 1-.317-.188c-.089-.07-.964-.934-1.945-1.918C.062 9.463 0 9.388 0 9.003c0-.39.053-.453 2.06-2.458C3.1 5.507 4.018 4.623 4.099 4.58a.947.947 0 0 1 .402-.079.854.854 0 0 1 .885.886.927.927 0 0 1-.079.402c-.043.081-.564.638-1.159 1.236l-1.08 1.089H8.39c5.087.002 5.331.005 5.496.08a.953.953 0 0 1 .525.808c0 .328-.223.67-.528.809-.16.073-.435.077-5.493.077l-5.324.001 1.081 1.089c.595.599 1.116 1.155 1.16 1.236.123.236.107.61-.037.855-.208.353-.688.535-1.053.4Z"
      fill="#BECDE0"
    />
  </svg>
);

export default LogoutIcon;
